export const bedsMockData = [
  {
    bedId: 'BED-101',
    ward: 'Cardiology',
    roomNumber: 'A-101',
    bedStatus: 'Occupied',
    patientAssigned: 'John Smith',
    patientId: 'PT-1001',
    bedType: 'Standard',
    expectedAvailability: '2023-08-20T14:00:00',
    admissionDate: '2023-08-15T09:30:00'
  },
  {
    bedId: 'BED-102',
    ward: 'Cardiology',
    roomNumber: 'A-101',
    bedStatus: 'Available',
    patientAssigned: null,
    patientId: null,
    bedType: 'Standard',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-103',
    ward: 'Cardiology',
    roomNumber: 'A-102',
    bedStatus: 'Occupied',
    patientAssigned: 'Emma Wilson',
    patientId: 'PT-1023',
    bedType: 'Telemetry',
    expectedAvailability: '2023-08-17T10:00:00',
    admissionDate: '2023-08-14T14:45:00'
  },
  {
    bedId: 'BED-104',
    ward: 'Cardiology',
    roomNumber: 'A-102',
    bedStatus: 'Cleaning',
    patientAssigned: null,
    patientId: null,
    bedType: 'Telemetry',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-105',
    ward: 'Neurology',
    roomNumber: 'B-201',
    bedStatus: 'Occupied',
    patientAssigned: 'Michael Brown',
    patientId: 'PT-1045',
    bedType: 'Critical Care',
    expectedAvailability: '2023-08-22T16:30:00',
    admissionDate: '2023-08-12T10:15:00'
  },
  {
    bedId: 'BED-106',
    ward: 'Neurology',
    roomNumber: 'B-201',
    bedStatus: 'Available',
    patientAssigned: null,
    patientId: null,
    bedType: 'Critical Care',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-107',
    ward: 'Neurology',
    roomNumber: 'B-202',
    bedStatus: 'Occupied',
    patientAssigned: 'Sarah Davis',
    patientId: 'PT-1067',
    bedType: 'Standard',
    expectedAvailability: '2023-08-16T09:00:00',
    admissionDate: '2023-08-10T13:20:00'
  },
  {
    bedId: 'BED-108',
    ward: 'Neurology',
    roomNumber: 'B-202',
    bedStatus: 'Occupied',
    patientAssigned: 'James Anderson',
    patientId: 'PT-1075',
    bedType: 'Standard',
    expectedAvailability: '2023-08-19T11:30:00',
    admissionDate: '2023-08-13T15:40:00'
  },
  {
    bedId: 'BED-109',
    ward: 'Orthopedics',
    roomNumber: 'C-301',
    bedStatus: 'Occupied',
    patientAssigned: 'Robert Johnson',
    patientId: 'PT-1105',
    bedType: 'Specialized',
    expectedAvailability: '2023-08-25T10:00:00',
    admissionDate: '2023-08-11T08:15:00'
  },
  {
    bedId: 'BED-110',
    ward: 'Orthopedics',
    roomNumber: 'C-301',
    bedStatus: 'Available',
    patientAssigned: null,
    patientId: null,
    bedType: 'Specialized',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-111',
    ward: 'Orthopedics',
    roomNumber: 'C-302',
    bedStatus: 'Occupied',
    patientAssigned: 'Patricia White',
    patientId: 'PT-1112',
    bedType: 'Standard',
    expectedAvailability: '2023-08-18T13:45:00',
    admissionDate: '2023-08-13T09:30:00'
  },
  {
    bedId: 'BED-112',
    ward: 'Orthopedics',
    roomNumber: 'C-302',
    bedStatus: 'Cleaning',
    patientAssigned: null,
    patientId: null,
    bedType: 'Standard',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-113',
    ward: 'Pediatrics',
    roomNumber: 'D-401',
    bedStatus: 'Occupied',
    patientAssigned: 'Thomas Wilson',
    patientId: 'PT-1124',
    bedType: 'Pediatric',
    expectedAvailability: '2023-08-17T15:00:00',
    admissionDate: '2023-08-12T11:00:00'
  },
  {
    bedId: 'BED-114',
    ward: 'Pediatrics',
    roomNumber: 'D-401',
    bedStatus: 'Available',
    patientAssigned: null,
    patientId: null,
    bedType: 'Pediatric',
    expectedAvailability: null,
    admissionDate: null
  },
  {
    bedId: 'BED-115',
    ward: 'Pediatrics',
    roomNumber: 'D-402',
    bedStatus: 'Occupied',
    patientAssigned: 'Elizabeth Brown',
    patientId: 'PT-1135',
    bedType: 'Pediatric',
    expectedAvailability: '2023-08-19T09:15:00',
    admissionDate: '2023-08-14T10:30:00'
  },
  {
    bedId: 'BED-116',
    ward: 'Pediatrics',
    roomNumber: 'D-402',
    bedStatus: 'Cleaning',
    patientAssigned: null,
    patientId: null,
    bedType: 'Pediatric',
    expectedAvailability: null,
    admissionDate: null
  }
]
